import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';

import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import LazyLoading from '../../../components/LazyLoading';

import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { Currency } from '../../../app/models/Currency';
import useCurrencyService from '../../../app/services/hooks/useCurrencyService';
import ForeignExchangeForm from './forms/ForeignExchangeForm';
import useForeingExchangeService from '../../../app/services/hooks/useForeignExchangeService';
import { ForeignExchanges, defaultForeignExchangeDataForm } from '../../../app/models/ForeignExchange';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
    manually?: boolean
}

const ForeignExchangeCreate = ({ onSaved, onCancel, onError, manually=false }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);


    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [foreignExchange, setForeignExchange] = useState<ForeignExchanges>(defaultForeignExchangeDataForm)

    const [errorFields, setErrorFields] = useState<any>();
    const [errorGetData, setErrorGetData] = useState('');

    
    const { fetchingCreateForeignExchanges, 
        fetchingStoreForeignExchanges,
        createForeignExchange, 
        storeForeignExchange,
        storeManuallyForeignExchange
    } = useForeingExchangeService();

    useEffect(() => {
        if (showLoading) showLoading('loading', 'Cargando datos...');
        createForeignExchange({
            onSuccess: (response: ServiceResponse) => {
                setCurrencies(response.data.currencies);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                setErrorGetData(response.message);
                if (onError) onError();
            }
        });
    }, []);

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando moneda...');
        if(manually){
            storeManuallyForeignExchange(foreignExchange, {
                onSuccess: (response: ServiceResponse) => {
                    if (hideLoading) hideLoading();

                    useReactConfirmAlert().successAlert({
                        title: 'Éxito',
                        message: response.message
                    });
                    toast.success(response.message, {
                        autoClose: 2500
                    });
                    if (onSaved) onSaved();
                },
                onError: (response: ServiceResponse) => {
                    if (hideLoading) hideLoading();
                    useReactConfirmAlert().errorAlert({
                        title: 'Error',
                        message: response.message
                    });
                },
                onFieldError: (errorFields: ServiceResponse) => {
                    if (hideLoading) hideLoading();

                    setErrorFields(errorFields.data);
                }
            });
        }else{
            storeForeignExchange(foreignExchange, {
                onSuccess: (response: ServiceResponse) => {
                    if (hideLoading) hideLoading();

                    useReactConfirmAlert().successAlert({
                        title: 'Éxito',
                        message: response.message
                    });
                    toast.success(response.message, {
                        autoClose: 2500
                    });
                    if (onSaved) onSaved();
                },
                onError: (response: ServiceResponse) => {
                    if (hideLoading) hideLoading();
                    useReactConfirmAlert().errorAlert({
                        title: 'Error',
                        message: response.message
                    });
                },
                onFieldError: (errorFields: ServiceResponse) => {
                    if (hideLoading) hideLoading();

                    setErrorFields(errorFields.data);
                }
            });
        }

    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    if (errorGetData !== '') {
        return <div>{errorGetData}</div>;
    }

    return fetchingCreateForeignExchanges ? (
        <LazyLoading height={300} />
    ) : (
        <>
            <div className="row">
                <div className="col-12">
                    <ForeignExchangeForm
                        currencies={currencies}
                        foreignExchangesDataForm={foreignExchange}
                        setforeignExchangesDataForm={setForeignExchange}
                        errorFields={errorFields}
                        manually={manually}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStoreForeignExchanges} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreForeignExchanges} />
                </div>
            </div>
        </>
    );
};

export default ForeignExchangeCreate;
